import React from "react";

import { Card as AntCard } from "antd";

import { Icon } from "components";

export const TablePanel = ({
  extra = null,
  headline,
  badges = null,
  image = null,
  icon = null,
  tag = null,
  onClick = null,
  className = "",
  dataTestId = "",
  subtitle = null,
}) => (
  <AntCard data-testid={dataTestId || headline} className={`table-panel ${className} ${onClick ? "pointer" : ""}`} onClick={onClick}>
    {image || (icon && <div className="image-container">{image || <Icon iconName={icon} size="m" />}</div>)}
    <div className={`left ${(image || icon) && "margin-left-50"}`}>
      {tag}
      <h6 className="left">
        {headline}
        {badges && <span className="badges">{badges}</span>}
      </h6>
      {subtitle && <span className="paragraph-xs grey-text">{subtitle}</span>}
    </div>
    {extra}
  </AntCard>
);

export default TablePanel;
